import React from 'react';

function DeleteTodoList({ TodoData }) {
  const todo = TodoData || {};

  return (
    <>
      <div className="text-left px-2 pb-0">
        <h6>Following todo item will be deleted and could not be recovered!!</h6>
        <ul>
          <li><b>Title :</b> {todo.Title || '-'}</li>
          <li><b>Description :</b> {todo.Description || '-'}</li>
        </ul>
      </div>
      <div id="DeleteTodoDetails" hidden>{JSON.stringify(todo)}</div>
    </>
  );
}

export default DeleteTodoList;
